module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","core"],"commonjs":"@angular/core","commonjs2":"@angular/core","amd":"@angular/core"}
// module id = 0
// module chunks = 0 1